<div class="main-container">
  <!-- <div class="label-container">
    <label for="">Approve</label>
  </div> -->

  <div class="no-request-container">
    <div class="icon-container" *ngIf="type == 'no-requests'">
      <img src="/assets/icons/no-requests.png" alt="" />
      <label for=""> No request pending </label>
      <p>You are all set!</p>
    </div>
    <div class="icon-container" *ngIf="type == 'no-access'">
      <img src="/assets/icons/no-access.png" alt="" />
      <label for=""> You Have no Access </label>
    </div>
  </div>
</div>
